import { createFileRoute } from "@tanstack/react-router";
import { bookmarkListInfiniteQueryOptions } from "~/features/favorites/api";
import { footprintListInfiniteQueryOptions } from "~/features/footprint/api";
import { myProfileQueryOptions } from "~/features/myProfile/api";
import { MyProfileTemplate } from "~/features/myProfile/MyProfileTemplate";

export const Route = createFileRoute("/_authenticated/profile/")({
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(myProfileQueryOptions),
      queryClient.ensureInfiniteQueryData(footprintListInfiniteQueryOptions),
      queryClient.ensureInfiniteQueryData(bookmarkListInfiniteQueryOptions),
    ]),
  component: MyProfileTemplate,
});
